export default function calculateRadians(degrees: number): number {
  return (degrees * Math.PI) / 180;
}
